import Vue, { createApp } from 'vue';

import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import store from './store'
import './registerServiceWorker'
// import vueSmoothScroll from 'vue-smoothscroll'
// Vue.use(vueSmoothScroll)

import Vue3Lottie from "vue3-lottie";
import 'vue3-lottie/dist/style.css'


import en from "./translations/en.json"

const messages = {
  "en": en
}
const i18n = createI18n({
  locale: 'en',
  messages: messages
})


  createApp(App).use(router).use(i18n).use(Vue3Lottie).use(store).mount('#app')
